module.exports = __webpack_public_path__ + "static/img/three-blue.fb24bceb.png";